import { Theme } from 'mf-ui-components'

export function fontSize<
  Token extends keyof Theme['typography']['font']['sizes']
>(token: Token) {
  return ({ theme }: { theme: Theme }) =>
    `${theme.typography.font.sizes[token]}px`
}
